import { decode } from 'jsonwebtoken';
import { JWT_COOKIE_KEY } from '../consts';

/**
 * Checks if a token has not expired
 * @param token
 */
export function isTokenValid(token: string | null): boolean {
  if (!token) {
    return false;
  }
  try {
    const decodedJwt: any = decode(token);
    return decodedJwt.exp >= Date.now() / 1000;
  } catch (e) {
    return false;
  }
}

/**
 * Checks is a user is logged in
 */
export function isLoggedIn(): boolean {
  return isTokenValid(window.localStorage.getItem(JWT_COOKIE_KEY));
}
